module.exports = __webpack_public_path__ + "static/media/product-2.a9c9a748.jpg";